import axios from 'axios';

export const getOfficesFetchPath = () => '/ajaxRoute/franchiseeList';

export const getRestApiClient = () => axios;
